<div class="flex px-4 pb-4 pt-5 border-b border-stroke-tertiary">
  <button
    type="button"
    class="flex items-center gap-2 py-[2px] text-xs text-foreground-primary-100 transition-colors disabled:text-action-secondary dark:disabled:text-action-secondary-text"
    [title]="'ai-assistant.new-chat' | translate"
    [disabled]="isNewChat()"
    (click)="onNewChat()"
  >
    <svg-icon key="plus-16" size="16" />
    <span>{{ 'ai-assistant.new-chat' | translate }}</span>
  </button>
</div>

<div class="p-4 text-xs text-foreground-primary-40">
  {{ 'ai-assistant.previous-chats' | translate }}
</div>

<app-ai-conversation-list
  [items]="conversationListVm()"
  [isLoading]="conversationsLoading()"
  [hasMore]="conversationsHasMore()"
  [loadingMore]="conversationsLoading() && conversationListVm().length > 0"
  (conversationSelected)="onConversationSelected()"
  (loadMore)="onLoadMore()"
/>

<div class="mt-auto flex items-center gap-4 px-4 py-3 text-xs border-t border-stroke-tertiary">
  <span class="text-foreground-primary-40">{{ 'ai-assistant.beta-access' | translate }}</span>
  <button type="button" class="text-action-secondary dark:text-action-secondary-text hover:underline">
    {{ 'ai-assistant.feedback' | translate }}
  </button>
</div>
